import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import {
  PENDING_WITHDRAWALS_ACCEPT_MUTATION_KEY,
  PENDING_WITHDRAWALS_ACCEPT_URL,
  PENDING_WITHDRAWALS_LIST_QUERY_KEY,
  PENDING_WITHDRAWALS_PERMISSIONS,
} from '../constants';

export default function usePendingWithdrawalsAcceptMutation(): IContextMutationResult<
  void,
  Error,
  number
> {
  const { displayPresetToast } = useToastStore();
  const { fetchPut } = useRestClient();

  return useContextMutation<void, Error, number>({
    mutationKey: [PENDING_WITHDRAWALS_ACCEPT_MUTATION_KEY],
    mutationFn: (id) => fetchPut<void>(
      PENDING_WITHDRAWALS_ACCEPT_URL,
      {},
      {
        permission: PENDING_WITHDRAWALS_PERMISSIONS.EDIT,
        urlParams: { id },
      },
    ),
    onSuccess({ queryClient }) {
      displayPresetToast('success');
      void queryClient.invalidateQueries({ queryKey: [PENDING_WITHDRAWALS_LIST_QUERY_KEY] });
    },
  });
}
